export default function getRandomInt(min, max) {
    const range = max - min + 1;
    const byteArray = new Uint8Array(1);

    window.crypto.getRandomValues(byteArray);

    const randomValue = byteArray[0] % range;

    return min + randomValue;
}